import { MsalProvider } from '@azure/msal-react';
import type { PropsWithChildren } from 'react';

import { msalInstance } from './msalInstance';
import { PortalSessionProvider } from './PortalSessionProvider';

export function AuthProvider({ children }: PropsWithChildren) {
  return (
    <MsalProvider instance={msalInstance}>
      <PortalSessionProvider>
        {children}
      </PortalSessionProvider>
    </MsalProvider>
  );
}
